<template>
    <div>
        <!-- 右键菜单 -->
        <div v-show="contextMenu.visible"
             :style="{position: 'fixed', top: contextMenu.y + 'px', left: contextMenu.x + 'px'}"
             class="context-menu">
            <el-menu class="menu" @select="handleMenuSelect">
                <el-menu-item index="delete">
                    <el-icon>
                        <Delete/>
                    </el-icon>
                    删除用户
                </el-menu-item>

                <el-menu-item v-if="contextMenu.row.isBlack === 2" index="addBlack">
                    <el-icon>
                        <Warning/>
                    </el-icon>
                    拉黑用户
                </el-menu-item>
                <el-menu-item v-else-if="contextMenu.row.isBlack === 1" index="removeBlack">
                    <el-icon>
                        <Unlock/>
                    </el-icon>
                    取消拉黑
                </el-menu-item>

                <el-menu-item v-if="contextMenu.row.userType === 1" index="setWhite">
                    <el-icon>
                        <User/>
                    </el-icon>
                    添加为代理
                </el-menu-item>
                <el-menu-item v-else-if="contextMenu.row.userType === 2" index="setWhite">
                    <el-icon>
                        <User/>
                    </el-icon>
                    解除代理
                </el-menu-item>

                <el-menu-item index="addIDFABlack">
                    <el-icon>
                        <WarningFilled/>
                    </el-icon>
                    拉黑设备
                </el-menu-item>
                <el-menu-item index="removeIDFABlack">
                    <el-icon>
                        <Unlock/>
                    </el-icon>
                    取消拉黑设备
                </el-menu-item>
            </el-menu>
        </div>
    </div>
</template>


<script>
    import {ElMessage} from 'element-plus';
    import {addBlack, addIDFABlack, deleteById, removeBlack, removeIDFABlack, setWhite} from "../api/user/user";

    export default {
        name: "Header",
        data() {
            return {
                contextMenu: {
                    visible: false,
                    x: 0,
                    y: 0,
                    row: {},
                    index: -1
                },
            }
        },
        mounted() {
        },
        methods: {
            // 右键菜单处理
            handleContextMenu(row, column, event) {
                console.log("row:"+row);
                console.log("column:"+column);
                console.log("event:"+event);
                event.preventDefault(); // 阻止默认右键菜单

                // 记录当前操作的行
                this.contextMenu.row = row;
                this.contextMenu.index = this.withdrawList.indexOf(row);

                // 显示自定义菜单
                this.contextMenu.visible = true;
                this.contextMenu.x = event.clientX;
                this.contextMenu.y = event.clientY;
            },

            // 隐藏上下文菜单
            hideContextMenu() {
                this.contextMenu.visible = false;
            },

            // 菜单项选择处理
            handleMenuSelect(command) {
                this.contextMenu.visible = false;

                // 根据命令调用相应方法
                const row = this.contextMenu.row;
                const index = this.contextMenu.index;

                switch(command) {
                    case 'delete':
                        this.handleDeleteUser(index, row);
                        break;
                    case 'addBlack':
                        this.addBlack(index, row);
                        break;
                    case 'removeBlack':
                        this.removeBlack(index, row);
                        break;
                    case 'setWhite':
                        this.setWhite(index, row);
                        break;
                    case 'addIDFABlack':
                        this.addIDFABlack(index, row);
                        break;
                    case 'removeIDFABlack':
                        this.removeIDFABlack(index, row);
                        break;
                }
            },

            //删除
            handleDeleteUser(index, row) {
                debugger
                this.loading = true;
                deleteById(row.userId).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '删除成功',
                            type: 'success',
                        });
                    }else {
                        this.loading = false;
                        ElMessage.error('删除失败');
                    }
                    this.loading = false;
                });
                console.log(index, row);
            },

            //加白
            setWhite(index, row) {
                debugger
                this.loading = true;
                setWhite(row.userId).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '设置成功',
                            type: 'success',
                        });
                    } else {
                        this.loading = false;
                        ElMessage.error('设置成功');
                    }
                    this.loading = false;
                });
            },

            //拉黑
            addBlack(index, row) {
                this.loading = true;
                addBlack(row.userId).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '设置成功',
                            type: 'success',
                        });
                    }else {
                        this.loading = false;
                        ElMessage.error('设置成功');
                    }
                    this.loading = false;
                });
            },
            //取消拉黑
            removeBlack(index, row) {
                this.loading = true;
                removeBlack(row.userId).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '取消拉黑成功',
                            type: 'success',
                        });
                    }else {
                        this.loading = false;
                        ElMessage.error('取消拉黑失败');
                    }
                    this.loading = false;
                });
            },

            //设备拉黑
            addIDFABlack(index, row) {
                this.loading = true;
                addIDFABlack(row.idfa).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '设备拉黑成功',
                            type: 'success',
                        });
                    }else {
                        this.loading = false;
                        ElMessage.error('设备拉黑失败');
                    }
                    this.loading = false;
                });
            },

            //取消设备拉黑
            removeIDFABlack(index, row) {
                this.loading = true;
                removeIDFABlack(row.idfa).then(res => {
                    const code = res.data.code;
                    console.log(res.data);
                    if (code === "200") {
                        this.selectData();
                        this.loading = false;
                        ElMessage({
                            message: '取消设备拉黑成功',
                            type: 'success',
                        });
                    } else {
                        this.loading = false;
                        ElMessage.error('取消设备拉黑失败');
                    }
                    this.loading = false;
                });
            },
        }
    }
</script>

<style lang="less" scoped>

    .dialog_div {
        width: 90%;
        margin-left: 5%;
        display: flex;
        justify-content: space-between;
        color: gray;
    }

    .context-menu {
        position: fixed;
        z-index: 9999;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background: #fff;
    }

    .menu {
        border: none;
    }


</style>